export const translations = {
  declareInformation: {
    pt: 'Declaro, que as informações inseridas no sistema estão de acordo com o contrato estabelecido com a Evonik.',
    en: 'I declare that the information entered into the system is in accordance with the contract established with Evonik.',
    es: 'Declaro que la información ingresada en el sistema está de acuerdo con el contrato establecido con Evonik.',
    de: 'Ich erkläre, dass die in das System eingegebenen Informationen mit dem mit Evonik geschlossenen Vertrag übereinstimmen.',
  },
  cancelButton: {
    pt: 'Cancelar',
    en: 'Cancel',
    es: 'Cancelar',
    de: 'Abbrechen',
  },
  submitButton: {
    pt: 'Salvar',
    en: 'Save',
    es: 'Guardar',
    de: 'Speichern',
  },
  deleteButton: {
    pt: 'Deletar',
    en: 'Delete',
    es: 'Eliminar',
    de: 'Löschen',
  },
};
